// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullChampionshipResultTable,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputCheckbox,
  InputDoubleButton,
  InputNumber,
} from '@vroskus/library-components';

// Types
type $Props = $Translate & {
  item: $FullChampionshipResultTable | $ModelUpsertParams<'ChampionshipResultTable'>;
};

const ChampionshipResultTableFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col xs={4}>
          <InputDoubleButton
            label={t('Visibility')}
            labelFalse={t('Hidden')}
            labelTrue={t('Visible')}
            name={'Public'}
            value={item.Public}
          />
        </Col>
        <Col xs={8}>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={'align-checkbox'}>
            <InputCheckbox
              label={t('Invert points')}
              name={'InvertPoints'}
              value={item.InvertPoints}
            />
          </div>
        </Col>
        <Col>
          <InputNumber
            label={t('Discards')}
            name={'Discards'}
            required
            value={item.Discards}
          />
        </Col>
      </Row>
    </>
  );
};

export default ChampionshipResultTableFieldsView;
